import { gql } from 'graphql-request'

export const REMOVE_POPUP_BANNER = gql`
  mutation RemovePopupBanner($removePopupBannerId: Int!) {
    removePopupBanner(id: $removePopupBannerId) {
      message
    }
  }
`
